module.exports = __webpack_public_path__ + "img/thumb-cailey-on.003cf79e.jpg";